<template>
    <div class="verify-wrapper">
      <!-- <Logo :isTitle="true" :width="200" :color="'green'" :clickable="true" /> -->
      <v-toolbar-title class="taption-logo no-nav">
      <router-link :to="getLogoUrl">
        <img alt="logo" :src='"../assets/images/logo_green_title.webp"' style="height:52px; width: 200px; display: block"/>
      </router-link>
      </v-toolbar-title>
      <section ref="authenticationform" class="authentication-form">
          <form>
  
              <div class="verify-card card" >
                  <div v-show="isRedirecting">
                      {{$lang.login.redirecting}}
                  </div>
                  <div v-show="isComplete" class="email-verified"> 
                      <span class="title">{{successTitle}}</span>
                      <div class="fading-line"></div>
                      <div><a @click="onRedirect">{{$lang.account.click_here}}</a> {{$lang.account.if_not_direct}}</div>
                  </div>
                 <div v-show="isResetPassword" class="reset-password"> 
                     <v-form ref="passwordform">
                     <span class="title">{{$lang.account.create_password}}</span>
                     <v-text-field            
                      v-model="newPassword"
                      height="40px"
                      type='password'
                      :label="$lang.account.new_password"
                       :rules="requiredRules" 
                       required
                      :hint="$lang.error.must_be_more_than.format(8)"
                      autocomplete="off"
                      @click:append="show1 = !show1"
                      />
  
                      <v-text-field            
                      v-model="confirmPassword"
                      height="40px"
                      type='password'
                      :label="$lang.account.confirm_password"
                      :hint="$lang.error.must_be_more_than.format(8)"
                      autocomplete="off"
                      :rules="passwordRules" 
                      required 
                      @click:append="show1 = !show1"
                      />
  
                      <button type="button" class="btn btn-custom " @click="confirmNewPassword">{{$lang.account.update_password}}</button>
                        </v-form>
                  </div>
  
                  
                 <div v-show="isResetPassword" class="reset-password"> 
  
  
                  </div>
  
              </div>
  
  
          </form>
      </section>
    </div>
  </template>
  
  <script>
import userService from '../connections/user.service';
import textHelper from "@/utils/textManager";
  export default {
    name: "VerifyPage",
    components: {
    },
    data() {
      return {
          isResetPassword:false,
          isEmailVerified:false,
          isEmailRecoverd: false,
          newPassword:'',
          confirmPassword:'',
          show1: true,
          isMatch:false,
          isComplete: false,
          isRedirecting:false,
          email:'',
          actionCode:'',
          passwordRules:[],
          requiredRules:[],
          successTitle:''
      };
    },
    watch:{
        newPassword(newVal){
            const me = this;
            me.isMatch = me.confirmPassword === newVal
        },
        confirmPassword(newVal){
            const me = this;
            me.isMatch = me.newPassword === newVal
        },
        isComplete(newVal){
            const me = this;
            if(newVal){
                setTimeout(function(){
                  me.onRedirect();
                }, 4000);
            }
        }
    },
    computed: {
      isPasswordFormValid() {
        const me = this;
        return me.$refs.passwordform.validate();
      },
      getLogoUrl() {
        const language =  textHelper.getDisplayLanguage();
        if(language === 'zh'){
            return { name: "taptiontw" };
        }
        else if(language === 'zh-CN'){
            return { name: "taptioncn" };
        }
        else if(language === 'en-US' || language === 'en'){
            return { name: "taption" };
        }
        else{
            return { name: `taption${language}` };
        }
       }
    },
    methods:{
        onReset(){
            const me = this;
            me.isComplete = false;
            me.isMatch = false;
             me.isRedirecting = false;
          me.requiredRules = [
          v => !!v || me.$lang.payment.required_field.format(me.$lang.account.password),
          v => (v  && v .length >= 8) || me.$lang.error.must_be_more_than.format(8)
          ];
  
          me.passwordRules = [
          v => !!v || me.$lang.payment.required_field.format(me.$lang.account.password),
          () => me.newPassword === me.confirmPassword || me.$lang.error.password_not_match
          ];
        },
        onRedirect(){
          window.location.href = window.location.origin + '/login';
        //  me.$router.push({ name: 'login' });
        },
        getParameterByName(name){
          if (name !== "" && name !== null && name != undefined) {
              name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
              var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                  results = regex.exec(location.search);
              return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
          } else {
              var arr = location.href.split("/");
              return arr[arr.length - 1];
          }
        },
        handleResetPassword(actionCode){
            const me = this;
            userService.verifyPasswordResetCode(actionCode).then(function(email) {
            //  auth.verifyPasswordResetCode(actionCode).then(function(email) {
                  me.email = email;
                  me.actionCode = actionCode;
                  me.isResetPassword = true;
  
              }).catch(function() {
                //  alert(error);
                  me.onRedirect();
              });
        },
        confirmNewPassword(){
            const me = this;
       //   const auth = firebase.app().auth();
          // Save the new password.
          if(me.isPasswordFormValid){
              me.successTitle = me.$lang.account.password_update;
              userService.confirmPasswordReset(me.actionCode, me.newPassword).then(function() {
              //auth.confirmPasswordReset(me.actionCode, me.newPassword).then(function(resp) {
              // Password reset has been confirmed and new password updated.
              me.isResetPassword = false;
              me.isComplete = true;
              }).catch(function(error) {
                  alert(error);
              });
          }
          
        },
        handleRecoverEmail( actionCode){
            const me = this;
          // Localize the UI to the selected language as determined by the lang
          // parameter.
          // var restoredEmail = null;
          // Confirm the action code is valid.
          userService.checkActionCode(me.actionCode).then(function() {
              // Get the restored email address.
              // restoredEmail = info['data']['email'];
  
              // Revert to the old email.
              return userService.applyActionCode(actionCode);
          }).then(function() {
              // Account email reverted to restoredEmail
  
              // TODO: Display a confirmation message to the user.
              me.successTitle = me.$lang.account.email_verified;
              me.isEmailRecoverd = false;
              me.isComplete = true;
  
              // // You might also want to give the user the option to reset their password
              // // in case the account was compromised:
              // auth.sendPasswordResetEmail(restoredEmail).then(function() {
              // // Password reset confirmation sent. Ask user to check their email.
              // }).catch(function(error) {
              // // Error encountered while sending password reset code.
              // });
          }).catch(function() {
                  me.onRedirect();
              // Invalid code.
          });
        },
        handleVerifyEmail(actionCode){
            const me = this;
  
            userService.applyActionCode(actionCode).then(function() {
              // Email address has been verified.
            me.successTitle = me.$lang.account.email_verified + '🎉🎉';
              me.isEmailVerified = false;
              me.isComplete = true;
              // TODO: Display a confirmation message to the user.
              // You could also provide the user with a link back to the app.
  
              // TODO: If a continue URL is available, display a button which on
              // click redirects the user back to the app via continueUrl with
              // additional state determined from that URL's parameters.
          }).catch(function() {
             //     alert(error);
                  me.onRedirect();
              // Code is invalid or expired. Ask the user to verify their email address
              // again.
          });
        },
        handleSignIn(continueUrl, email){
            const me = this;
            const chunks = continueUrl.split('/');
            
  
            me.isRedirecting = true;
            userService.signInWithEmailLink(email, window.location.href)
              .then(function() {
              // Clear email from storage.
        me.$router.push({ name: "edittranscript", params: { id: chunks[chunks.length-1] } });
            //  var test = result;
            //  window.location.href = continueUrl;
              
             // window.localStorage.removeItem('emailForSignIn');
              // You can access the new user via result.user
              // Additional user info profile not available via:
              // result.additionalUserInfo.profile == null
              // You can check if the user is new or existing:
              // result.additionalUserInfo.isNewUser
              })
              .catch(function() {
        me.$router.push({ name: "edittranscript", params: { id: chunks[chunks.length-1] } });
                 // me.onRedirect();
              // Some error occurred, you can inspect the code: error.code
              // Common errors could be invalid email and invalid or expired OTPs.
              });
        }
    },
    mounted(){
        const me = this;
          const mode = me.getParameterByName('mode');
          // Get the one-time code from the query parameter.
          const actionCode = me.getParameterByName('oobCode');
          // (Optional) Get the continue URL from the query parameter if available.
          const continueUrl = me.getParameterByName('continueUrl');
          // (Optional) Get the language code if available.
          const lang = me.getParameterByName('lang') || 'en-US';
  
          const email = me.getParameterByName('email')
          
         // const auth = firebase.app().auth();
  
          me.onReset();
  
          // Handle the user management action.
          switch (mode) {
              case 'resetPassword':
              // Display reset password handler and UI.
              me.handleResetPassword(actionCode, continueUrl, lang);
              break;
              case 'recoverEmail':
              // Display email recovery handler and UI.
              me.handleRecoverEmail(actionCode, lang);
              break;
              case 'verifyEmail':
              // Display email verification handler and UI.
              me.handleVerifyEmail(actionCode, continueUrl, lang);
              break;
              case 'signIn':
              me.handleSignIn(continueUrl, email);
              break;
              default:
                  me.$router.push({name:'login'});
              // Error: invalid mode.
          }
    }
  }
  </script>
  
  <style>
  .verify-card.card{
      min-height: 100px;
      text-align: center;
      height:auto;
  }
  
  .verify-card .v-input__slot{
      -webkit-box-shadow: 0 0 5px 0 hsla(0,0%,66.7%,.35);
      box-shadow: 0 0 5px 0 hsla(0,0%,66.7%,.35);
  }
  
  .verify-card .v-text-field__slot>input{
      padding-left:10px;
  }
  .verify-card .v-text-field__slot>label{
      padding:0px 10px;
      font-size:14px;
      color:gray;
  }
  .verify-card .v-text-field__slot:after{
  }
  
  
  </style>
  
  
  <style scoped>
  >>>.v-input__slot:before{
      display: none!important;
  }
  .card{
          box-shadow: 0 1px 4px rgba(1,1,1,.15);
      cursor: default!important;
  }
  .logo {
  position: absolute;
      top: 42px;
      left: 75px;
  }

  .verify-wrapper{
    background:rgb(216 240 236 / 20%);
    height:100%;
  }
  
  .verify-wrapper .authentication-form{
      /* min-height: 100vh; */

      justify-content: center;
    display: flex;
    align-items: center;
    margin-top: 0px !important;
    padding-top:0px!important;
  }

  .authentication-form .verify-card {
    box-shadow: 0 1px 10px rgba(1, 1, 1, 0.25);
    cursor: default !important;
  
    border-radius: 10px;
    padding:20px;
    margin-top: 200px;
    background: white;
    border-bottom: 3px solid #1ad7dd !important;
  }
  
  .verify-card .btn{
      width:100%;
  }
  
  .verify-card a{
    text-decoration: underline!important;
    color: #2fc59f !important;
  }
  .verify-card a:hover{
    opacity: 0.5;
  
  }

  .taption .verify-wrapper,
.verify-wrapper{
  background-image: url('../assets/images/about.webp')!important;
  background-repeat: repeat;
  /* background-image: url(/img/1.130a2cda.png); */
}

.email-verified{

}
  </style>